import type { Document } from "../document/Document";
import type { Command } from "./Command";

// Replace the entire document. Undo returns to the previous document
// (or to the empty state).

export class LoadDocumentCommand implements Command {
  readonly kind = "load-document";
  constructor(private readonly next: Document) {}
  apply(_doc: Document): Document {
    return this.next;
  }
  invert(before: Document, _after: Document): Command {
    return new LoadDocumentCommand(before);
  }
}
